import {budgetConstants} from '../constants';

const budgetState = {
  budgetRequest: null,
  budgets: [],
};

const budgetReducer = (state = budgetState, action) => {
  const {type} = action;
  switch (type) {
    case budgetConstants.SET_BUDGET_REQUEST:
      return {
        ...state,
        budgetRequest: action.data
      };
    case budgetConstants.SET_BUDGETS:
      return {
        ...state,
        budgets: action.data
      }
    case budgetConstants.CLEAR_BUDGET_REQUEST:
      return {
        ...state,
        budgetRequest: null
      }
    case budgetConstants.ADD_BUDGET_TO_STORE:
      return {
        ...state,
        budgets: [...state.budgets, action.data]
      }
    case budgetConstants.UPDATE_BUDGET_IN_STORE:
      return {
        ...state,
        budgets: state.budgets.map(budget =>
          budget.id === action.data.id ? action.data : budget
        )
      };
    default:
      return state;
  }
};

export default budgetReducer;
